import React, { Component } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import { links, constants, snowplow } from 'common/helpers'
import { FormattedHTMLMessage } from 'sb-react-intl'

import ModalWithActions from 'components/modal/ModalWithActions/ModalWithActions'

import messages from './messages'


export default class GetBackTogetherModal extends Component {

  static propTypes = {
    name: PropTypes.string,
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
  }

  static defaultProps = {
    name: constants.modals.resubscribe.GetBackTogether,
    title: messages.title,
  }

  constructor() {
    super()

    this.actions = [
      {
        id: 'btnResubscribe',
        brand: true,
        title: messages.btnResubscribe,
        onClick: this.handleClickResubscribe,
      },
      {
        id: 'btnResubscribeAndChangeFrequency',
        brand: true,
        title: messages.btnResubscribeAndChangeFrequency,
        onClick: () => this.handleClickChangeFrequency(),
      },
      {
        id: 'btnNotYet',
        whiteGray: true,
        title: messages.btnNotYet,
        onClick: () => this.close(),
      },
    ]
  }

  handleClickChangeFrequency = () => {
    const { name } = this.props

    this.close()
    actions.models.modals.open(constants.modals.ChangeFrequency, {
      popup: constants.analyticsEvents.resubscribePopup.getBackTogether,
      onCancel: () => actions.models.modals.open(name),
    })
  }

  handleClickResubscribe = () => {
    snowplow.track(constants.snowplowEvents.resubscribeClick, { placement: 'get back together popup' }, false)

    actions.models.subscription.resubscribe({
      withErrorHandler: false,
      popup: constants.analyticsEvents.resubscribePopup.getBackTogether,
    })
      .then(({ premiumProduct }) => {
        if (premiumProduct) {
          actions.models.modals.open(constants.modals.premiumProducts.WelcomeBack, {
            item: premiumProduct,
          })
        }
        else {
          actions.models.modals.open(constants.modals.resubscribe.SuccessfullyResubscribed)
        }

        this.close()
      }, () => {
        actions.misc.cookies.setItem('reactivateSubscription', {
          messageTitle: messages.paymentPageTitle,
        })

        actions.misc.cookies.removeItem(constants.cookieNames.offer)
        actions.misc.cookies.removeItem(constants.cookieNames.discountCoupon)

        this.close()
        actions.models.router.push(links.subscribe)
      })
  }

  close = () => {
    const { name } = this.props

    actions.models.modals.close(name)
  }

  render() {
    const { name, title } = this.props

    return (
      <ModalWithActions
        id={name}
        name={name}
        title={title}
        actions={this.actions}
      >
        <FormattedHTMLMessage tag="div" {...messages.text} />
      </ModalWithActions>
    )
  }
}
